import b from 'b_';
import cx from 'classnames';
import React from 'react';

import './live-indicator.scss';

export enum LIVE_INDICATOR_SIZE {
    S = 's',
    M = 'm',
    L = 'l',
}

interface Props {
    isInfinite?: boolean;
    mix?: string;
    size?: LIVE_INDICATOR_SIZE;
}

const LiveIndicator = ({ isInfinite = true, mix, size = LIVE_INDICATOR_SIZE.S }: Props) => {
    const cxPulse = b('live-indicator', 'pulse', { size, infinite: isInfinite });

    return (
        <div className={cx(b('live-indicator', { size }), mix)}>
            <div className={b('live-indicator', 'dot', { size })} />
            <div className={cxPulse} />
            <div className={cx(cxPulse, 'live-indicator__pulse-delay')} />
        </div>
    );
};

export default LiveIndicator;
